import React from 'react';

import { Typography } from './typography/typography.component';

import { Card, CardContent, CardHeader } from '../surface/card/card.component';

type ICardLayoutProps = {
  children?: React.ReactNode;
  title: string;
};

export const CardLayout = ({ title, children }: ICardLayoutProps) => {
  return (
    <Card>
      <CardHeader
        title={
          <Typography variant='h6' component='h4' gutterBottom>
            {title}
          </Typography>
        }
      />
      <CardContent>{children}</CardContent>
    </Card>
  );
};
